var exports = {
  "kL": "xaf9ae18d--bc92a7--container",
  "Wf": "xaf9ae18d--bc92a7--rounded",
  "mc": "xaf9ae18d--bc92a7--middle",
  "as": "xaf9ae18d--bc92a7--large",
  "n2": "xaf9ae18d--bc92a7--extra-large",
  "vu": "xaf9ae18d--bc92a7--active",
};

module.exports = exports;
